<template>
  <CContainer fluid>
    <h3>Indicadores Eventos en Facturas de Venta</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="3">
            <label class="col-12 text-muted font-weight-bold">
              Fecha Inicial:
            </label>
            <DatePicker 
              type="date" 
              class="col-12" 
              v-model="fechaInicial" 
              value-type="YYYY-MM-DD" 
              format="DD/MM/YYYY"
              placeholder="dd/mm/yyyy" />
          </CCol>
          <CCol col="3">
            <label class="col-12 text-muted font-weight-bold">
              Fecha Final:
            </label>
            <DatePicker 
              type="date" 
              class="col-12" 
              v-model="fechaFinal" 
              value-type="YYYY-MM-DD" 
              format="DD/MM/YYYY"
              placeholder="dd/mm/yyyy" />
          </CCol>
          <CCol col="6">
            <CButton 
              color="info" 
              variant="outline" 
              class="mt-4" 
              @click="getDataEventsSalesInvoices()">
              <CIcon name="cil-search" />
              <span class="ml-2 align-middle">Consultar</span>
              <CSpinner 
                size="sm" 
                class="ml-2" 
                v-show="loading" />
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CRow>
      <CCol col="6">
        <CCard>
          <CCardBody>
            <CRow>
              <CCol col="12">
                <CRow>
                  <CCol col="6">
                    <CCallout color="info">
                      <span class="text-muted">Sin evento</span>
                      <div>
                        <i class="bi bi-file-earmark h2 text-info mr-3"></i>
                        <!-- <i class="bi bi-receipt h2 text-info mr-3"></i> -->
                        <strong class="h4">{{ cantidadSinEvento }}</strong>
                      </div>
                    </CCallout>
                    <CCallout color="dark">
                      <span class="text-muted">Acuse de recibo</span>
                      <div>
                        <i class="bi bi-envelope-paper h2 text-dark mr-3"></i>
                        <!-- <i class="bi bi-receipt h2 text-dark mr-3"></i> -->
                        <strong class="h4">{{ cantidadAcuseRecibo }}</strong>
                      </div>
                    </CCallout>
                    <CCallout color="s3rose">
                      <span class="text-muted">Recibo del bien y/o servicio</span>
                      <div>
                        <i class="bi bi-bag-check h2 text-s3rose mr-3"></i>
                        <!-- <i class="bi bi-receipt h2 text-s3yellow mr-3"></i> -->
                        <strong class="h4">{{ cantidadReciboBienServicio }}</strong>
                      </div>
                    </CCallout>
    
                  </CCol>
                  <CCol col="6">
                    <CCallout color="danger">
                      <span class="text-muted">Reclamo en documento</span>
                      <div>
                        <i class="bi bi-file-earmark-x h2 text-danger mr-3"></i>
                        <!-- <i class="bi bi-receipt h2 text-danger mr-3"></i> -->
                        <strong class="h4">{{ cantidadReclamoDocumento }}</strong>
                      </div>
                    </CCallout>
                    <CCallout color="s3green">
                      <span class="text-muted">Aceptacion expresa</span>
                      <div>
                        <i class="bi bi-file-earmark-check h2 text-s3green mr-3"></i>
                        <!-- <i class="bi bi-receipt h2 text-s3green mr-3"></i> -->
                        <strong class="h4">{{ cantidadAceptacionExpresa }}</strong>
                      </div>
                    </CCallout>
                    <CCallout color="warning">
                      <span class="text-muted">Aceptacion t&aacute;cita</span>
                      <div>
                        <i class="bi bi-exclamation-diamond h2 text-warning mr-3"></i>
                        <!-- <i class="bi bi-receipt h2 text-warning mr-3"></i> -->
                        <strong class="h4">{{ cantidadAceptacionTacita }}</strong>
                      </div>
                    </CCallout>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
        
      </CCol>
      <CCol col="6">
        <CCard>
          <CCardBody>
            <CRow>
              <CCol col="12">
                <div 
                  class="d-flex justify-content-between"
                  @click="(e) => downloadReportEventStatusInvoices(e)">
                  <h4 class="mb-3">Eventos en Facturas de Venta</h4>
                  <i class="bi bi-cloud-arrow-down text-s3green h3"></i>
                </div>
              </CCol>
              <CCol col="12">
                <CDataTable 
                  hover
                  :responsive=true
                  :fields="fields" 
                  :items="data"
                  :noItemsView="{ noItems: '' }">
                  <template #evento="{ item }">
                    <td>
                      <span>{{ item.Evento }}</span>
                      <h4>{{ item.Codigo_Evento }}</h4>
                    </td>
                  </template>
                  <template #valores="{item}">
                    <td>
                      <div class="text-right">
                        <i class="bi bi-cash-coin mr-1" />
                        <strong>{{ formatter.format(item.Valor_Total) }}</strong>
                      </div>
                      <div class="text-right">
                        <span>{{ item.Cantidad }}</span>
                      </div>
                    </td>
                  </template>
                </CDataTable>
                
              </CCol>
            </CRow>
            <CRow>
              <CCol col="sm-12">
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

      </CCol>
      <CCol col="6">

      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
  import "vue2-datepicker/index.css";

  import moment from "moment";
  import DatePicker from "vue2-datepicker";
  import { formatter } from "@/general";
  import { downloadBase64File } from "@/api";
  import { 
    dataEventosFacturasVenta,
    descargarEstadosEventosFacturasVenta 
  } from "@/apis/sales";

  const fields = [
    { 
      key: "evento", 
      label: "Evento", 
      _style: "text-align:center;"
    },
    { 
      key: "valores",
      label: "Valores",
      _style: "text-align:center;"
    }
  ]
  
  export default {
    name: "DashboardEventsSalesInvoices",
    components: {
      DatePicker
    },
    data() {
      return {
        formatter,
        loading: false,
        fields,
        updateComponent: 0,
        fechaInicial: "",
        fechaFinal: "",
        data: [],
        cantidadSinEvento: 0,
        cantidadAcuseRecibo: 0,
        cantidadReciboBienServicio: 0,
        cantidadReclamoDocumento: 0,
        cantidadAceptacionExpresa: 0,
        cantidadAceptacionTacita: 0
      }
    },
    methods: {
      async getDataEventsSalesInvoices() {
        // e.preventDefault();
        // e.stopPropagation();

        this.loading = true;

        try {
          this.cantidadSinEvento = 0;
          this.cantidadAcuseRecibo = 0;
          this.cantidadReciboBienServicio = 0;
          this.cantidadReclamoDocumento = 0;
          this.cantidadAceptacionExpresa = 0;
          this.cantidadAceptacionTacita = 0;
          
          const parameters = {
            "Fecha_Inicial": this.fechaInicial,
            "Fecha_Final": this.fechaFinal,
            "Tipo_Reporte": "R"
          }
          const { response } = await dataEventosFacturasVenta(this, null, null, parameters);
          this.data = response;

          response.forEach(item => {
            switch (item.Codigo_Evento) {
              case "":
                this.cantidadSinEvento = item.Cantidad;
                break;
              case "030":
                this.cantidadAcuseRecibo = item.Cantidad;
                break;
              case "032":
                this.cantidadReciboBienServicio = item.Cantidad;
                break;
              case "031":
                this.cantidadReclamoDocumento = item.Cantidad;
                break;
              case "033":
                this.cantidadAceptacionExpresa = item.Cantidad;
                break;
              case "034":
                this.cantidadAceptacionTacita = item.Cantidad;
                break;
            }
          });

          this.updateComponent += 1;
        } catch(error) {
          console.log(error.data);
          this.$store.commit("setAlert", {
            color: "danger",
            message: `Error: ${error.status} - ${error.statusText} - ${error.data ? error.data.errorMessage : ""}`,
            show: 5
          });
        } finally {
          this.loading = false;
        }
      },
      async downloadReportEventStatusInvoices(e) {
        e.preventDefault();
        e.stopPropagation();

        this.loading = true;

        try {
          const parameters = {
            "Fecha_Inicial": this.fechaInicial,
            "Fecha_Final": this.fechaFinal,
            "Tipo_Reporte": "D"
          }

          const { response } = await descargarEstadosEventosFacturasVenta(this, parameters);
          const { nombreArchivo, contenidoArchivo } = response;

          downloadBase64File("vnd.ms-excel", contenidoArchivo, nombreArchivo);
        } catch(error) {
          console.log(error.data);
          this.$store.commit("setAlert", {
            color: "danger",
            message: `Error: ${error.status} - ${error.statusText} - ${error.data ? error.data.errorMessage : ""}`,
            show: 5
          });
        } finally {
          this.loading = false;
        }
      }
    },
    created() {
      this.rootPath = this.$router.currentRoute.fullPath.split("/")[1];
      this.fechaInicial = moment().startOf("month").format("YYYY-MM-DD");
      this.fechaFinal = moment().format("YYYY-MM-DD");

      this.getDataEventsSalesInvoices();
    },
    mounted() {
    },
    beforeDestroy() {
    }
  }
</script>
